import { useUserPage } from '@features/admin/users/hooks/useUserPage';
import { UserAdminProfileForm } from '@features/user-account/UserAdminProfileForm';
import { useAdminApi } from '@hooks/useAdminApi';
import { Box } from '@mui/material';
import { Organization } from '@protos/organization';
import React, { useEffect, useState } from 'react';

const UserPage: React.FC = () => {
  const { user } = useUserPage();
  const [orgData, setOrgData] = useState<Organization | undefined>(undefined);
  const { apiClient } = useAdminApi();

  const fetchOrgData = async () => {
    if (user?.organization_id) {
      const response = await apiClient?.getOrganization(user?.organization_id);
      setOrgData(response);
    }
  };

  useEffect(() => {
    fetchOrgData();
  }, [user?.organization_id]);

  if (!user) return null;
  return (
    <Box margin={2} paddingTop={2} marginTop={0}>
      <UserAdminProfileForm user={user} orgData={orgData} />
    </Box>
  );
};

export default UserPage;
